import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import swal from "sweetalert2";
import { MatDialog } from '@angular/material/dialog';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { ApiService,StrongPasswordRegx } from '../../service/api.service';
import { HelperService } from '../../service/helper.service';
import {CustomPasswordValidator} from '../../store/custom-password-validator'

@Component({
  selector: 'app-customer-registration',
  templateUrl: './customer-registration.component.html',
  styleUrls: ['./customer-registration.component.scss']
})
export class CustomerRegistrationComponent implements OnInit {

  sidebarMenuName: string;
  addCustomerForm: FormGroup;
  personalDetailsForm: FormGroup;
  addressDetailsForm: FormGroup;
  title = 'Add';
  topTitle2 = 'ORDERMANAGEMENT.MENUHOME';
  topTitle3 = 'ORDERMANAGEMENT.ADDUNIT';
  AlphaNumeric: '^([a-zA-Z0-9]+)$';
  unitIdRequest: any;
  RecordFiltered: any[] = [];
  country: any[] = []
  countryRecordFiltered: any[] = [];
  region: any[] = [];
  regionRecordFiltered: any[] = [];
  provList = [];
  selectedStatesId: any;
  citiesRecord: any;
  citiesRecordFiltered: any;
  statesRecord: any;
  provListRecordFiltered: any[];
  companyId: any;
  resionId: any;
  provisionName: any;
  customerId: any;
  hide = true;
  @ViewChild('stepper') stepper!: MatStepper;
  isStep1Valid: boolean = false;
  isStep2Valid: boolean = false;
  isStep3Valid: boolean = false;
  isStep4Valid: boolean = false;
  emailExists = false;
  errorMessage: any;

  countrySearchControl = new FormControl('');
  provinceSearchControl = new FormControl('');
  regionSearchControl = new FormControl('');
  citySearchControl = new FormControl('');

  constructor(
    private _formBuilder: FormBuilder,
    private helper: HelperService,
    public translate: TranslateService,
    private router: Router,
    public route: ActivatedRoute,
    private Api_Service: ApiService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {

    this.addCustomerForm = this._formBuilder.group({
      codeId: [''],
      companyName: ['', [HelperService.noWhitespaceValidator, Validators.required]],
      contactName: [''],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$')])],
      password: ['', [Validators.required, Validators.pattern(StrongPasswordRegx)]],
      mobileNumber: [''],
      countryName: ['', [HelperService.noWhitespaceValidator, Validators.required]],
      sdi: [''],
      taxIdCode: [''],
      vatCode: [''],
      pecMail: ['', [ Validators.pattern('^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$')]],
      region: ['', [Validators.required]],
      city: ['', [Validators.required]],
      province: ['', [Validators.required]],
      street: [''],
      zipCode: [''],
      customerReferenceName: [''],
      paymentTerms: [''],
      internalRating: [''],
      internalComment: ['']
    });

    this.personalDetailsForm = this._formBuilder.group({
      codeId: [''],
      companyName: ['', [HelperService.noWhitespaceValidator, Validators.required]],
      contactName: [''],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$')])],
      password: ['', [Validators.required,Validators.pattern(StrongPasswordRegx)]],
      mobileNumber: [''],
      sdi: [''],
      taxIdCode: [''],
      vatCode: [''],
      pecMail: ['', [ Validators.pattern('^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$')]],
      customerReferenceName: [''],
      paymentTerms: [''],
    })

    this.addressDetailsForm = this._formBuilder.group({
      countryName: ['', [HelperService.noWhitespaceValidator, Validators.required]],
      region: ['', [Validators.required]],
      city: ['', [Validators.required]],
      province: ['', [Validators.required]],
      street: [''],
      zipCode: [''],
    })

    this.sideMenuName();
    this.sideMenuName()
    this.getcountryList({});


  }

  get password() {
    return this.personalDetailsForm.get('password');
  }


  sideMenuName() {
    this.sidebarMenuName = this.translate.instant('ORDERMANAGEMENT.UNITMENU');
    //this.helper.sideMenuListName.next(this.sidebarMenuName);
  }


  emailCheck() {
    if (this.personalDetailsForm.get('email').valid) {
      this.personalDetailsForm.get('email')?.valueChanges
        .pipe(
          debounceTime(300),
          distinctUntilChanged(),
          switchMap(value => this.Api_Service.emailCheckService(value).pipe(
            catchError((error: HttpErrorResponse) => {
              this.emailExists = null;
              return of(null);
            })
          ))
        )
        .subscribe((response: any) => {
          if (response) {
            if (response.result) {
              if (response.data) {
                this.emailExists = true;
              } else {
                this.emailExists = false;
              }
            } else {
              this.emailExists = false;
              this.errorMessage = null;
            }
          }
        });
  }
  }




  // nextStep() {
  //   // console.log(this.addCustomerForm.value,"this.addCustomerForm")
  //   if (this.stepper.selectedIndex === 0 && this.addCustomerForm.controls['companyName'].valid &&
  //     this.addCustomerForm.controls['codeId'].valid &&
  //     this.addCustomerForm.controls['pecMail'].valid &&
  //     this.addCustomerForm.controls['email'].valid  && this.addCustomerForm.controls['password'].valid) {
  //     this.isStep1Valid = true; // Check validity of Step 1 form
  //     this.cdRef.detectChanges();
  //     this.stepper.next();
  //     console.log('called this 1 tab')
  //   }
  //   else if (this.stepper.selectedIndex === 1 && this.addCustomerForm.controls['countryName'].valid &&
  //     this.addCustomerForm.controls['region'].valid &&
  //     this.addCustomerForm.controls['province'].valid && this.addCustomerForm.controls['city'].valid
  //     && this.addCustomerForm.controls['street'].valid
  //     && this.addCustomerForm.controls['zipCode'].valid) {
  //     this.isStep2Valid = true; // Check validity of Step 2 form
  //     this.cdRef.detectChanges();
  //     this.stepper.next();
  //     console.log('called this 2 tab')
  //   }
  //   else if (this.stepper.selectedIndex === 2 && this.addCustomerForm.controls['customerReferenceName'].valid
  //     && this.addCustomerForm.controls['paymentTerms'].valid
  //     && this.addCustomerForm.controls['internalRating'].valid
  //   ) { // Ensure Step 2 is valid before proceeding to Step 3
  //     this.isStep3Valid = true; // Check validity of Step 3 form
  //     this.cdRef.detectChanges();
  //     this.stepper.next();
  //     console.log('called this 3 tab')
  //   }else{
  //     console.log('called poup')
  //     this.cdRef.detectChanges();
  //     this.helper.showMandatoryFieldsPopup();
  //     return;
  //   }
  // }

  nextStep(formGroup: FormGroup, step:any) {
    console.log(step,"step")
    if (formGroup.valid) {
      this.cdRef.detectChanges();
      console.log("stepper",this.stepper.selectedIndex)
      if(step === 1) {
        this.stepper.next()
      }else{
        this.addCustomer()
      };
    } else {
      formGroup.markAllAsTouched();
      this.cdRef.detectChanges();
      this.helper.showMandatoryFieldsPopup();
      return;
    }
  }


  getcountryList(request) {
    this.helper.toggleLoaderVisibility(true);
    this.Api_Service.getCountryList().subscribe((res: any) => {
      if (res) {
        this.country = res.data;
        this.countryRecordFiltered = this.country.slice();
        this.helper.toggleLoaderVisibility(false);
      } else {
        this.helper.toggleLoaderVisibility(false);
        // const e = err.error;
        swal.fire(
          '',
          // err?.error?.message,
          this.translate.instant(res.reason),
          'info'
        );
      }
    })

    this.helper.toggleLoaderVisibility(false);
  }



  changeCountry(id: any, isChange) {
    this.helper.toggleLoaderVisibility(true);
    this.resetState(isChange)
    this.Api_Service.getStatesList({ countryID: id }).subscribe((res: any) => {
      if (res) {
        this.region = res.data;
        this.statesRecord = this.region;
        this.regionRecordFiltered = this.region.slice();
        this.helper.toggleLoaderVisibility(false);
      } else {
        this.helper.toggleLoaderVisibility(false);
        // const e = err.error;
        swal.fire(
          '',
          // err?.error?.message,
          this.translate.instant(res.reason),
          'info'
        );
      }
    })

    this.helper.toggleLoaderVisibility(false);
  }


  changeState(stateName,isChange) {
    const stateData = this.statesRecord;
    if (isChange) {
      this.addCustomerForm.patchValue({
        city: '',
        province: '',
      });
    }
    if (stateData) {
      for (let i = 0; i < stateData?.length; i++) {
        if (stateData[i].id == stateName) {
          this.selectedStatesId = stateData[i].id;
          this.Api_Service.getSelectedProvince({ id: stateName }).subscribe((data) => {
             this.provList = data.data.map((code: string, index: number) => ({
              id: index,      // or use code itself if it’s unique
              name: code      // display value
            }));
            this.provListRecordFiltered = this.provList.slice();
        
          });
        }
      }
    }
  }

  changeProvince(provinceName,isChange) {
    const provData = this.provList;
    if (isChange) {
      this.addCustomerForm.patchValue({
        city: '',
      });
    }
    // for (let i = 0; i < provData?.length; i++) {
    //   if (provData[i] == provinceName) {
    //     this.selectedStatesId = provData[i];
        this.Api_Service.getCitiesList({ province: provinceName }).subscribe((data) => {
          this.citiesRecord = data.data;
          this.citiesRecordFiltered = this.citiesRecord.slice();
        });
    //   }
    // }
  }




  trimFormValues(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control && control.value && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });
  }



  addCustomer() {
    console.log("clicked");
    
    // Trim form values before using them
    this.trimFormValues(this.personalDetailsForm);
    this.trimFormValues(this.addressDetailsForm);

    // let requestBody = {
    //   ...this.personalDetailsForm.value,
    //   ...this.addressDetailsForm.value
    // }

    let requestBody = {
      codeId: this.personalDetailsForm.controls['codeId'].value ? this.personalDetailsForm.controls['codeId'].value : '',
      companyName: this.personalDetailsForm.controls['companyName'].value,
      email: this.personalDetailsForm.controls['email'].value,
      contactName: this.personalDetailsForm.controls['contactName'].value ? this.personalDetailsForm.controls['contactName'].value : null,
      mobileNumber: this.personalDetailsForm.controls['mobileNumber'].value ? this.personalDetailsForm.controls['mobileNumber'].value : null,
      country: this.addressDetailsForm.controls['countryName'].value,
      region: this.addressDetailsForm.controls['region'].value,
      city: this.addressDetailsForm.controls['city'].value,
      province: this.addressDetailsForm.controls['province'].value,
      street: this.addressDetailsForm.controls['street'].value ? this.addressDetailsForm.controls['street'].value : '',
      zipCode: this.addressDetailsForm.controls['zipCode'].value ? this.addressDetailsForm.controls['zipCode'].value : '',
      customerReferenceName: this.personalDetailsForm.controls['customerReferenceName'].value ? this.addCustomerForm.controls['customerReferenceName'].value : '',
      paymentTerms: this.personalDetailsForm.controls['paymentTerms'].value ? this.addCustomerForm.controls['paymentTerms'].value : '',
      // internalRating: this.addCustomerForm.controls['internalRating'].value ? this.addCustomerForm.controls['internalRating'].value : '',
      // internalComments: this.addCustomerForm.controls['internalComment'].value ? this.addCustomerForm.controls['internalComment'].value : '',
      password: this.personalDetailsForm.controls['password'].value,
      
      pecMail:  this.personalDetailsForm.controls['pecMail'].value || "",
      vatCode:  this.personalDetailsForm.controls['vatCode'].value || "",
      taxIdCode:  this.personalDetailsForm.controls['taxIdCode'].value || "",
      sdi:  this.personalDetailsForm.controls['sdi'].value || "",
    }

    // if (this.addCustomerForm.valid) {
      this.helper.toggleLoaderVisibility(true);
      //  Customer registration
        this.Api_Service.registrationCustomer(requestBody).subscribe((res: any) => {
          this.helper.toggleLoaderVisibility(false);
          if (res.result) {
            this.router.navigate(['signup-submit']);
            swal.fire('',
              this.translate.instant(res.message),
              'success');
          }
        }, (err) => {
          this.helper.toggleLoaderVisibility(false);
          swal.fire(
            '',
            this.translate.instant(err.error.message),
            'info'
          );
        });


    // }
  }

  resetState(isChange) {
    if (isChange) {
      this.addCustomerForm.patchValue({
        region: '',
        city: '',
        province: '',
      });
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  space(event: any): void {
    this.emailCheck()
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault();
    }
  }
}
